import { partition } from 'lodash'

import { SelectOptionType } from '@revolut-internal/ui-kit'

const sortChildren = <Value, Option extends SelectOptionType<Value>>(
  options: Option[],
  selectedSet: Set<Value>,
) =>
  options.map(option => ({
    ...option,
    ...('children' in option &&
      option.children && {
        children: sortRecursively(option.children, selectedSet),
      }),
  }))

const sortRecursively = <Value, Option extends SelectOptionType<Value>>(
  optionsToSort: Option[],
  selectedSet: Set<Value>,
): Option[] => {
  const [selected, unselected] = partition(
    optionsToSort,
    option => !!option.value && selectedSet.has(option.value),
  )

  const sortedSelected = sortChildren(selected, selectedSet)
  const sortedUnselected = sortChildren(unselected, selectedSet)

  return [...sortedSelected, ...sortedUnselected]
}

export const useOptionsWithSelectedOnTop = <
  Value,
  Option extends SelectOptionType<Value>,
>(
  options: Option[],
  value: Value[] | null,
) => {
  if (!value?.length || !options) {
    return options
  }

  const selectedSet = new Set(value)

  return sortRecursively(options, selectedSet)
}
